import { AbstractDocument, Identifiable, Timestampable } from '../../../abstract/Document';
import { AbstractCollection } from '../../../abstract/Collection';
import type { WithFieldValue } from 'firebase/firestore';
import { Identified, PartialMaybe, Timestamped } from '../../../abstract/_';
import type { ISupplierCalendarEvent } from './Events.types';
import { Calendar } from '../Calendars';
import { BroadcastMessages } from './Events/BroadcastMessages';

@Identifiable
@Timestampable
export class Event extends AbstractDocument<ISupplierCalendarEvent> {
  readonly collections = {
    BroadcastMessages: new BroadcastMessages(this),
  };

  /**
   * Returns the parent Calendar of this Event
   */
  get calendar() {
    return this.reference.parent.parent!.id;
  }
}

export class Events extends AbstractCollection<Event, ISupplierCalendarEvent> {
  static path = 'events';

  constructor(document: Calendar) {
    super(document.collection(Events.path), Event);
  }

  /**
   * Returns the parent Calendar of this Events collection
   */
  get calendar() {
    return this.reference.parent!.id;
  }

  /**
   * Creates a new calendar event
   *
   * @param data Object containing calendar event creation parameters
   */
  async create(data: WithFieldValue<PartialMaybe<ISupplierCalendarEvent, Identified & Timestamped>>): Promise<Event> {
    return await this.push().create(data as ISupplierCalendarEvent);
  }
}
